'use client';

import { atom } from 'jotai';

export const selectedProductIdAtom = atom<string | undefined>(undefined);

export const resetSelectedProductIdAtom = atom(null, (_get, set) => {
  set(selectedProductIdAtom, undefined);
});
